import { GrupoEconomico } from "./GrupoEconomico"
import { TamanhoDaEtiqueta } from "./EtiquetaDePreco"

export type CampoDeEtiqueta =
	| 'NOME_DA_LOJA'
	| 'SKU_PRODUTO_PAI'
	| 'SKU_PRODUTO'
	| 'NOME_DO_PRODUTO'
	| 'CODIGO_DE_BARRAS'
	| 'TEXTO_DO_EAN'
	| 'PRECO_DO_PRODUTO'
	| 'PRECO_DA_TABELA'
	| 'TRACO'

export type TipoDeAlinhamentoDeTexto = 'ESQUERDA' | 'CENTRO' | 'DIREITA'

export type TipoDeCodigoDeBarras = 'EAN13' | 'CODE128'

export type TipoDeDadoDoCampo = 'TEXTO' | 'NUMERO' | 'GRAFICO'

export interface CampoDeEtiquetaDisponivel {
	chave: CampoDeEtiqueta
	rotulo: string
	tipoDeDado: TipoDeDadoDoCampo
	requerTipoDeCodigoDeBarras: boolean
	valorDeExemplo: string
}

export interface CampoDoModeloDeEtiqueta {
	id: string
	campo: CampoDeEtiqueta | null
	x: number
	y: number
	largura: number
	altura: number
	tamanhoDaFonte: number
	negrito: boolean
	alinhamento: TipoDeAlinhamentoDeTexto
	tipoDeCodigoDeBarras: TipoDeCodigoDeBarras | null
	incluirNomeDaTabela: boolean
	incluirLimitacao: boolean
}

export interface ModeloDeEtiqueta {
	id: string
	descricao: string
	grupoEconomico: GrupoEconomico | null
	tamanho: TamanhoDaEtiqueta | null
	campos: CampoDoModeloDeEtiqueta[]
}

export const CAMPOS_QUE_DEPENDEM_DE_TABELA_DE_PRECO: CampoDeEtiqueta[] = [
	'PRECO_DA_TABELA',
]

export function montarTextoDePrecoDaTabela(
	campo: Pick<CampoDoModeloDeEtiqueta, 'incluirNomeDaTabela' | 'incluirLimitacao'>,
	nome: string,
	parcelaOuPreco: string,
	limitacao: string,
): string {
	let texto = ''
	if (campo.incluirNomeDaTabela && nome) texto += `${nome} - `
	texto += parcelaOuPreco
	if (campo.incluirLimitacao && limitacao) texto += ` ${limitacao}`
	return texto
}

export interface EntradaDeResolucaoDeValoresDeEtiqueta {
	produtosId: string[]
	idTabelas: string[]
	parcelasPorTabela: Record<string, number>
}

export interface ValoresDeCamposDeEtiqueta {
	produtoId: string
	idTabela: string
	nomeDaTabela: string
	preco: string
	parcelas: string
	limitacao: string
}

export interface ItemDeEtiquetaParaImprimir {
	produtoId: string
	quantidade: number
}

export interface EntradaDeImpressaoDeModeloDeEtiqueta {
	modeloId: string
	lojaId: string
	itens: ItemDeEtiquetaParaImprimir[]
	idTabelas: string[]
	parcelasPorTabela: Record<string, number>
}
export interface ElementoPosicionadoDeEtiqueta {
	tipoDeDado: TipoDeDadoDoCampo
	x: number
	y: number
	largura: number
	altura: number
	conteudo: string
	tamanhoDaFonte: number
	negrito: boolean
	alinhamento: TipoDeAlinhamentoDeTexto
	tipoDeCodigoDeBarras: TipoDeCodigoDeBarras | null
}

export interface ConteudoDeEtiquetasParaImprimir {
	tamanho: TamanhoDaEtiqueta
	paginas: ElementoPosicionadoDeEtiqueta[][]
}
